export type AnswerType = {
    userId?: number
    answered?: boolean
    score?: number
    comment?: string
    answeredAt?: string | number | null
    numberOfRetries?: number
    lastRetryAt?: string | number | null
    name?: string | null
}

type ConfigResponse<T> = {
    success: boolean
    data?: T
    error?: string
}

export type AnswerStatusType = {
    userId?: number
    answered?: boolean
    numberOfRetries?: number
    lastRetryAt?: string | number | null
}

export const npsApi = {
    getAnswers: (): Promise<ConfigResponse<AnswerType[]>> =>
        fetch('/services/plugin-nps/answers', {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' }
        }).then(response => response.json()),

    getAnswer: (userId: number): Promise<ConfigResponse<AnswerType>> =>
        fetch(`/services/plugin-nps/answer/${userId}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' }
        }).then(response => response.json()),

    getAnswerStatus: (userId: number): Promise<ConfigResponse<AnswerStatusType>> =>
        fetch(`/services/plugin-nps/answer-status/${userId}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' }
        }).then(response => response.json()),

    registerUser: (userId: number): Promise<ConfigResponse<AnswerType>> =>
        fetch('/services/plugin-nps/register', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId })
        }).then(response => response.json()),

    upsertUserAnswer: (answer: AnswerType): Promise<ConfigResponse<AnswerType>> =>
        fetch('/services/plugin-nps/answer', {
            method: 'PUT',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(answer)
        }).then(response => response.json()),

    deleteUserAnswer: (userId: number): Promise<ConfigResponse<{ deleted: boolean; userId: number }>> =>
        fetch(`/services/plugin-nps/answer/${userId}`, {
            method: 'DELETE',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' }
        }).then(response => response.json())
}
